(function () {
'use strict';

angular.module('hyresgastApp').controller('ListNegotiationMyCtrl', ListNegotiationMyCtrl);

function ListNegotiationMyCtrl($location, $filter,
  Negotiation,
  CombinedNegotiationStates, NegotiationTypes, Parties, Limits,
  Auth) {
  var vm = this;

  Auth.heartbeat().then(function () {
    vm.isHgfUser = Auth.currentUser().party === Parties.HGF;
    vm.tableColumns = [
      {
        title: 'Id',
        column: 'caseNumber'
      },
      {
        title: 'Namn',
        column: 'name'
      },
      {
        title: 'Organisation',
        column: 'counterpart.name'
      },
      {
        title: 'Förhandlingstyp',
        template: 'slot1',
        column: 'type',
        lookup: {
          idProperty: 'id',
          textProperty: 'text',
          dictionary: vm.negotiationTypeChoices,
          multi: true,
        },
      },
      {
        title: 'Status',
        template: 'status',
        column: 'combinedState',
        lookup: {
          idProperty: 'id',
          textProperty: 'text',
          dictionary: vm.statusChoices,
          multi: true,
        },
      },
      {
        title: 'Begärt ändringsdatum',
        column: 'rentEffectiveFrom'
      },
      {
        title: 'Önskat datum för förhandling',
        column: 'callForNegotiation.negotiationDate'
      },
      (vm.isHgfUser ? {
        title: 'Ansvarig motpart',
        column: 'extNegotiator.fullName',
        template: 'person',
      } : {
        title: 'Ansvarig HGF',
        column: 'hgfNegotiator.fullName',
        template: 'person',
      }),
      {
        title: '',
        template: 'comment',
        filterType: 'none'
      }
    ];
    vm.tableAttributes = [
      {
        fn: row => !row.seenByMe,
        legend: 'Oläst',
        class: 'table__tr--notseen',
      },
    ];
  });

  vm.statusChoices = Object.values(CombinedNegotiationStates).map(x => ({
    id: x,
    text: $filter('hyCombinedNegotiationStates')(x)
  }));
  vm.negotiationTypeChoices = Object.values(NegotiationTypes).map(x => ({
    id: x,
    text: $filter('hyNegotiationTypes')(x)
  }));
  vm.pageLimit = 30;
  vm.auth = Auth;

  ////////////

  vm.gotoNegotiation = (negotiation) => {
    $location.search({});
    $location.path('/negotiations/' + negotiation.id);
  }
  vm.tableFGetData = params => {
    // eslint-disable-next-line no-undef
    return new Promise((resolve, reject) => {
      params.mine = true;
      Negotiation.query(params)
        .$promise.then(result => resolve(result))
        .catch(err => reject(err));
    });
  };

  let getParams = (includeProperties) => {
    let tableauParams = vm.lastParams;
    tableauParams.limit = Limits.InMemoryMiddleLimit;
    tableauParams.offset = 0;
    if (includeProperties) {
      tableauParams.includeProperties = includeProperties;
    }
    return tableauParams;
  };
  vm.getAllNegotiations = (cb, includeProperties) => {
    Negotiation.query(getParams(includeProperties), {})
      .$promise.then(function (data) { cb(data) });
  };
}
})();